/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LpInspectionCouponDto } from '../../models/lp-inspection-coupon-dto';

export interface NonMemberControllerCheck$Params {
  childId: string;
  code: string;
}

export function nonMemberControllerCheck(http: HttpClient, rootUrl: string, params: NonMemberControllerCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponDto>> {
  const rb = new RequestBuilder(rootUrl, nonMemberControllerCheck.PATH, 'get');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.query('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LpInspectionCouponDto>;
    })
  );
}

nonMemberControllerCheck.PATH = '/api/non-member/check';
